import * as ExperiencesClient from 'flux/clients/experiences';
import { ExperienceSource } from 'model/IExperience';

import { ActionType } from './model';

export type ExperienceActions = {
  setExperience(
    shortId: string,
    lang: string,
    experience: ExperienceSource,
  ): void;
  fetchExperience(
    shortId: string,
    lang: string,
    currency: string,
    addLiveParam?: boolean,
  ): void;
  setNotFound(shortId: string, lang: string): void;
};

const REDIRECT_ERROR_CODE = 410;
const NOT_FOUND_ERROR_CODE = 404;

function actionsFactory(
  dispatch: (action: ActionType) => void,
): ExperienceActions {
  return {
    setExperience(shortId, lang, experience) {
      dispatch({
        type: 'FETCH_EXPERIENCE_SUCCESS',
        payload: {
          shortId,
          experience,
          lang,
          isInactive: experience.wasPublishedIsStillApproved,
        },
      });
    },
    fetchExperience(shortId, lang, currency, addLiveParam = false) {
      dispatch({ type: 'FETCH_EXPERIENCE' });
      ExperiencesClient.fetchExperience(shortId, lang, currency, addLiveParam)
        .then((experience) => {
          dispatch({
            type: 'FETCH_EXPERIENCE_SUCCESS',
            payload: {
              shortId,
              experience,
              lang,
              isInactive: experience.wasPublishedIsStillApproved,
            },
          });
        })
        .catch((error) => {
          if (error.status === REDIRECT_ERROR_CODE) {
            const redirectUrl = JSON.parse(error.responseText);
            dispatch({
              type: 'EXPERIENCE_REDIRECT_URL',
              payload: { lang, shortId, redirectUrl },
            });
          } else if (error.status === NOT_FOUND_ERROR_CODE) {
            dispatch({
              type: 'EXPERIENCE_NOT_FOUND',
              payload: { lang, shortId },
            });
          } else {
            dispatch({
              type: 'FETCH_EXPERIENCE_ERROR',
              payload: { lang, shortId },
            });
            throw error;
          }
        });
    },
    setNotFound(shortId, lang) {
      dispatch({ type: 'EXPERIENCE_NOT_FOUND', payload: { shortId, lang } });
    },
  };
}

export default actionsFactory;
